import { useSelector } from "react-redux";
import { ApplicationState } from "..";

export const useEntityTypeReducer = () => useSelector((state: ApplicationState) => state.entityType);
